import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getAggregateSaleData } from '@/service/sale/reportShangTong';
export default function useCommercialConcreteSaleData(params) {
  var aggregateSaleData = ref({
    totMoneyList: [],
    settleValueList: [],
    totalSettleValue: 0,
    totalMoney: 0,
    totalAveragePrice: 0,
    totalSingular: 0,
    timeRange: ''
  });
  // 获取主机汇总数据
  var getAggregateSaleDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAggregateSaleData(params.value);
          case 2:
            data = _context.sent;
            aggregateSaleData.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getAggregateSaleDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [aggregateSaleData, getAggregateSaleDataAsync];
}